export default "__VITE_ASSET__vwFZtQGw__"